<script lang="ts" setup>

  type Props = {
    small?: boolean
  }
  const props = defineProps<Props>()

  const model = defineModel<number[] | number>({ required: true })

  const holes = computed(() => Array.isArray(model.value) ? model.value : [model.value])

</script>
<template>
  <div class="c-holes">
    <div
      v-for="(hole, key) in holes"
      :key="`${hole}-${key}`"
      :class="{ small: props.small }"
      class="hole-container"
    >
      <div class="hole-content">
        <span>{{ hole }}</span>
        <SvgIcon
          icon="hole"
          :width="8"
          :height="12"
          :desktop-width="props.small ? 8 : 12"
          :desktop-height="props.small ? 12 : 18"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>

.c-holes {
  display: flex;
  flex-flow: row wrap;

  .hole-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.125em 0.25em;
    border-radius: 4px;
    background-color: var(--color-secondary-light);

    &:not(:last-child) {
      margin-right: 0.25em;
    }

    .hole-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      opacity: 0.7;

      span {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 0.875em;
        font-weight: 600;
      }

      .c-icon {
        padding: 0;
        margin-left: 0.25rem;
      }
    }
  }

  @media screen and (width >= 1024px) {
    .hole-container {
      &:not(:last-child) {
        margin-right: 0.5em;
      }

      .hole-content {
        span {
          font-size: 1.25em;
        }
      }

      &.small {
        .hole-content {
          span {
            font-size: 0.875em;
          }
        }
      }
    }
  }
}
</style>
